import { useState } from "react";
import { GrMenu, GrFacebookOption } from 'react-icons/gr';
import { FaTelegramPlane } from "react-icons/fa";
import { Drawer } from 'antd';
import { useUserDataContext } from '../contexts/userDataProvider';
import Loader from './common/Loader';
import ErrorAlert from './common/ErrorAlert';
import { useCoworkerRequestContext } from '../contexts/coworkerRequestProvider';
import AllProperties from './settings/properties/AllProperties';
import UserSettings from './settings/UserSettings';
import RemoveAccount from "./settings/RemoveAccount";

const SidePanel = () => {
  const [isSideNavOpen, setIsSideNavOpen] = useState(false);
  const [isCommonLoading, setIsCommonLoading] = useState(false);
  const [commonError, setCommonError] = useState({});

  const { translate } = useUserDataContext();

  const {
    isLoading: isLoadingCoworkerData,
    error: errorCoworkerData,
    isApprovedCoworker,
    workSpaceEmail,
    workSpaceId
  } = useCoworkerRequestContext();
  
  const showDrawer = () => {
    setIsSideNavOpen(true);
  };
  const onClose = () => {
    setIsSideNavOpen(false);
  };

const ContactUs = () => (
  <div className="contact-us-side-pannel">
    <p>
      {translate("telegramSupport")}
    </p>
    <a
      className="telegram-icon-link"
      href="https://t.me/Dimidrol_q"
      target="_blank" 
      rel="noopener noreferrer"
      aria-label="Telegram support"
    >
      <FaTelegramPlane />
    </a>
    <p>
      {translate("supportFeedbackIdeas")}
    </p>
    <a
      className="facebook-icon-link"
      href="https://www.facebook.com/groups/bookingapp"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Facebook group"
    >
      <GrFacebookOption />
    </a>
  </div>
);


  return (
    <div className="side-nav-wrap">
      <Loader 
        setIsLoading={isCommonLoading || isLoadingCoworkerData}
      />
      <ErrorAlert
        error={commonError || errorCoworkerData}
      />
      <GrMenu
        onClick={showDrawer}
        className="open-nav-button"
        title={translate("userSettings")}
      />
      <Drawer
        closable={{ 'aria-label': 'Close Button' }}
        onClose={onClose}
        open={isSideNavOpen}
        title={<ContactUs />}
      >
        <div className="side-nav-content">
          {!isApprovedCoworker && (
            <div className="sidenav-row-odd">
              <AllProperties />
            </div>
          )}

          <div className="sidenav-row-even">
            <UserSettings
              setIsSidePannelLoading={setIsCommonLoading}
              setSidePannelError={setCommonError}
              isApprovedCoworker={isApprovedCoworker}
              workSpaceEmail={workSpaceEmail}
              workSpaceId={workSpaceId}
            />
          </div>
          <div className="sidenav-row-odd">
            <RemoveAccount
              setIsLoading={setIsCommonLoading}
              setLocalError={setCommonError}
              workSpaceEmail={workSpaceEmail}
            />
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default SidePanel;
